import { updatePartner360Configuration } from 'legacy/lut/services/partner360/configuration/updatePartner360Configuration'
import { map621ToShareOfBusiness } from 'legacy/lut/services/partner360/shareOfBusiness/mappings/map621ToShareOfBusiness'
import { mapPartner360DeviceFormatToApiFields } from 'legacy/lut/services/partner360/shareOfBusiness/mappings/mapPartner360DeviceFormatToApi'
import { updatePartner360SOB } from 'legacy/lut/services/partner360/shareOfBusiness/updatePartner360SOB'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import {
  I621Form,
  selectFinancialYear,
  selectPartner360Data,
  selectProgramType,
} from '../../configuration'
import { REQUEST_PARTNER360_UPDATE_PARTNER_DEVICES_INFO } from '../constants'
import { calculateTopVendorsA3, calculateTopVendorsA4 } from '../helpers'
import { IShareOfBusiness } from '../models'
import { IPartnerDevicesInfoForm } from '../models'
import { selectDevicesInfo } from '../selectors/selectDevicesInfo'

type TThunkResult = {
  isShareOfBusinessUpdated: boolean
  data: IShareOfBusiness
}

export const requestUpdatePartnerDevicesInfo = createAsyncThunk<
  TThunkResult,
  IPartnerDevicesInfoForm
>(REQUEST_PARTNER360_UPDATE_PARTNER_DEVICES_INFO, async (form, { getState }) => {
  const state = getState()
  const configuration = selectPartner360Data(state)
  const devicesInfo = selectDevicesInfo(state)
  const programType = selectProgramType(state)
  const fYear = selectFinancialYear(state)

  const recalculatedA3 = calculateTopVendorsA3({
    ...devicesInfo.a3,
    hpBrand: form.A3HP,
    allBrands: form.A3AllBrands,
  })

  const recalculatedA4 = calculateTopVendorsA4({
    ...devicesInfo.a4,
    hpBrand: form.A4HP,
    allBrands: form.A4AllBrands,
  })

  const apiData: Partial<I621Form> = {
    EntryId: configuration.entryId,

    HPBrandsOverLastYears: form.overLastYears,
    ...mapPartner360DeviceFormatToApiFields({
      a3: recalculatedA3,
      a4: recalculatedA4,
    }),
  }

  const data = await updatePartner360Configuration({
    EntryId: configuration.entryId,
    PartnerId: configuration.partnerId,
    FYear: fYear,
    ...apiData,
  })

  const shouldUpdateShareOfBusiness = await updatePartner360SOB({
    partnerId: configuration.partnerId,
    fYear: configuration.fYear,
    programType: programType,
    devicesInfo: {
      ...devicesInfo,
      a3: recalculatedA3,
      a4: recalculatedA4,
    },
  })

  const mappedDevicesInfo = map621ToShareOfBusiness(data)

  return {
    isShareOfBusinessUpdated: shouldUpdateShareOfBusiness,
    data: mappedDevicesInfo,
  }
})
